export class AuthorizationInfo {
    constructor(serialNumber, pin) {
        this.serialNumber = serialNumber;
        this.pin = pin;
        this.SerialNumber = serialNumber;
        this.PIN = pin;
    }
}
export var ConnectionType;
(function (ConnectionType) {
    ConnectionType[ConnectionType["ByCloud"] = 0] = "ByCloud";
    ConnectionType[ConnectionType["LocalNetwork"] = 1] = "LocalNetwork";
    ConnectionType[ConnectionType["P2P"] = 2] = "P2P";
})(ConnectionType || (ConnectionType = {}));
export var ConnectionResult;
(function (ConnectionResult) {
    ConnectionResult[ConnectionResult["FailedToConnect"] = 0] = "FailedToConnect";
    ConnectionResult[ConnectionResult["AuthorizationFailed"] = 1] = "AuthorizationFailed";
    ConnectionResult[ConnectionResult["FailedToConnectToServer"] = 2] = "FailedToConnectToServer";
    ConnectionResult[ConnectionResult["Connected"] = 3] = "Connected";
    ConnectionResult[ConnectionResult["ControllerIsNotConnected"] = 4] = "ControllerIsNotConnected";
})(ConnectionResult || (ConnectionResult = {}));
export var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["Disconnected"] = 0] = "Disconnected";
    ConnectionState[ConnectionState["Connecting"] = 1] = "Connecting";
    ConnectionState[ConnectionState["Connected"] = 3] = "Connected";
    ConnectionState[ConnectionState["Disconnecting"] = 4] = "Disconnecting";
    ConnectionState[ConnectionState["Failed"] = 5] = "Failed";
    ConnectionState[ConnectionState["Reconnecting"] = 6] = "Reconnecting";
    ConnectionState[ConnectionState["ConnectedAndAuthorized"] = 7] = "ConnectedAndAuthorized";
})(ConnectionState || (ConnectionState = {}));
export class StreamError extends Error {
    constructor(message) {
        super(message);
        this.name = "StreamError";
    }
}
//# sourceMappingURL=IExalusConnectionService.js.map